import { alpha } from '@mui/material';
import type { Theme } from '@mui/material';

/**
 * Indigo zalohy (hasic jede, ale ceka ve zbrojnici na dalsi vuz). Zamerne NE info.main —
 * ta uz nese chip VD, KOPIS a smenu HZS. Odstiny schvalene v UX hodnoceni F1 (tmavy #7986CB ma kontrast 5,4:1 na #121212).
 */
export const ZALOHA_BARVA = '#3949AB';
export const ZALOHA_BARVA_TMAVA = '#7986CB';

export const zalohaBarva = (theme: Theme): string =>
    theme.palette.mode === 'dark' ? ZALOHA_BARVA_TMAVA : ZALOHA_BARVA;

/**
 * Text UVNITR indigo podkladu radku zalohy v nocnim rezimu. #7986CB ma na vlastnim podkladu
 * alpha 0,24 nad paper #1e1e1e jen 3,4:1; indigo 200 #9FA8DA ma 5,1:1 (nad #121212 5,8:1).
 */
export const ZALOHA_TEXT_NA_PODKLADU_TMAVA = '#9FA8DA';

/** Barva textu na podkladu tintZaloha (min. 4,5:1 dle UX F1); ve svetlem rezimu shodna se zalohaBarva. */
export const zalohaTextNaPodkladu = (theme: Theme): string =>
    theme.palette.mode === 'dark' ? ZALOHA_TEXT_NA_PODKLADU_TMAVA : ZALOHA_BARVA;

/** Podklad radku zalohy; pruhlednost ve svetlem rezimu predava volajici (shodne s tintNestiha). */
export const tintZaloha = (theme: Theme, svetlaPruhlednost: number): string =>
    alpha(zalohaBarva(theme), theme.palette.mode === 'dark' ? 0.24 : svetlaPruhlednost);
